import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"

const GRID = [3, 9, 15]
const STEP_DELAY_S = 0.11

/** 3×3 dot grid with a diagonal wave: the agent is replying in this chat. */
export function AgentWorkingDots({ className }: { className?: string }) {
  const { t } = useTranslation("agentActivity")
  return (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      role="status"
      aria-label={t("working")}
      className={cn("agent-working-dots h-4 w-4", className)}
    >
      {GRID.map((cy, row) =>
        GRID.map((cx, col) => (
          <circle
            key={`${row}-${col}`}
            className="agent-working-dot"
            cx={cx}
            cy={cy}
            r={2}
            style={{ animationDelay: `${(row + col) * STEP_DELAY_S}s` }}
          />
        )),
      )}
    </svg>
  )
}
